import React from 'react';

import CloneOpportunity from '../../opportunities/CloneOpportunity/CloneOpportunity';
import StageBadge from '../../opportunities/StageBadge';
import AddQuoteButton from '../../quotes/AddQuoteButton/AddQuoteButton';
import ListQuotes from '../../quotes/ListQuotes';
import ProjectOpportunityForm from './ProjectOpportunityForm';
import ProjectOpportunityFormWrapper from './ProjectOpportunityFormWrapper';

const renderProjectHeaderContent = (model, onChange, isEditing) => {
  return (
    <>
      <ProjectOpportunityForm
        opportunity={model}
        onChange={onChange}
        isEditing={isEditing}
      />
      <div className="mb-4" />
      <ListQuotes
        opportunityId={model.id}
        primaryQuoteId={model.primaryQuoteId}
        actions={<AddQuoteButton opportunityId={model.id} />}
        onUpdatePrimaryQuote={id => {
          onChange({ target: { name: 'primaryQuoteId', value: id } });
        }}
        isEditing={isEditing}
        showPagination={false}
      />
    </>
  );
};

const renderProjectHeaderTitle = ({ model }) => (
  <div className="d-flex align-items-center justify-content-between w-100">
    <div className="d-flex align-items-center">
      <h4 className="mb-0 mr-3">Opportunity</h4>
      <StageBadge stage={model.stage} />
    </div>
    <CloneOpportunity opportunity={model} />
  </div>
);

export default function ProjectHeader(props) {
  return (
    <ProjectOpportunityFormWrapper
      {...props}
      renderTitle={renderProjectHeaderTitle}
      renderContent={renderProjectHeaderContent}
    />
  );
}
